import { Col, Row } from '@maternity/mun-layout';
import { Anchor } from '@maternity/mun-router';
import * as React from 'react';

export function ContactInfo() {
  return (
    <Row>
      <Col xs={12}>
        <p className="contact-info">
          Questions about the Master Services Agreement? Contact us at{' '}
          <Anchor href="mailto:sales@quiltedhealth.com">
            sales@quiltedhealth.com
          </Anchor>
        </p>
      </Col>
    </Row>
  );
}
